import React, { useState } from "react";
import { useSelector } from "react-redux";
import ContentTabs from "../../../../ui/contentTabs/ContentTabs";
import UploadTab from "./uploadTab/UploadTab";
import GeneralIconsTab from "./generalIconsTab/GeneralIconsTab";
import classes from "./IconField.module.css";

const TAB_UPLOAD = "upload";
const TAB_ICON = "icon";

const IconField = ({ value, onFileChange, onUrlChange }) => {
    const { texts } = useSelector((state) => state.translate);
    const { defaultToolManagerIcons } = useSelector((state) => state.uiData.general);
    const iconsWithFullUrl = defaultToolManagerIcons?.map(icon => ({ ...icon, url: `${window.config.bucketFilesUrl}${icon.url}` }));
    const [activeTab, setActiveTab] = useState(value && iconsWithFullUrl?.some(icon => icon.url === value) ? TAB_ICON : TAB_UPLOAD);

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        onFileChange(null);
        onUrlChange("");
    };

    const tabs = [
        { id: TAB_UPLOAD, label: texts.uploadImage },
        { id: TAB_ICON, label: texts.chooseIcon },
    ];

    return (
        <div className={classes.Field}>
            <label className={classes.Label}>{texts.toolIcon}</label>
            <div className={classes.IconBox}>
                <ContentTabs
                    tabsName="iconField"
                    tabs={tabs}
                    activeTab={activeTab}
                    onTabChange={handleTabChange}
                >
                    {(tab) =>
                        <div className={classes.TabContent}>
                            {tab === TAB_UPLOAD ?
                                <UploadTab onFileChange={onFileChange} previewUrl={value} />
                                :
                                <GeneralIconsTab
                                    icons={iconsWithFullUrl}
                                    selectedUrl={value || ""}
                                    onSelect={onUrlChange}
                                />
                            }
                        </div>
                    }
                </ContentTabs>
            </div>
        </div>
    );
};

export default IconField;
